<tr>
    <td>{{entity.summary.product?.label}} <span *ngIf="entity.summary.comment"
                                                style="font-size: 0.75em;">({{entity.summary.comment}}
        )</span></td>
    <td>{{entity.summary.quantity}}</td>
    <td>{{entity.summary.vatRate}}%</td>
    <td>
        <app-price-label [price]="entity.summary.unitPriceVatExcluded"></app-price-label>
    </td>
    <td>
        <app-price-label [price]="entity.summary.unitPriceVatIncluded"></app-price-label>
    </td>
    <td>
        <app-price-label [price]="entity.summary.totalPriceVatIncluded"></app-price-label>
    </td>
    <td class="d-flex align-items-center justify-content-center">
        <app-button iconName="edit" tooltip="Modifier le prix" (clickEvent)="editPrice()"></app-button>
        <app-action-button
                (actionSuccessEvent)="productDeleted()"
                [buildPayload]="buildDeletePayload"
                [confirmationOptions]="{confirmationText: 'Confirmez-vous la suppression?', displayCancelButton:true}"
                [service]="deleteService"
                iconName="trash"></app-action-button>
    </td>
</tr>